import { MCF_REDIRECT_STATES } from '../../../config/mcf-redirect.config';

export function getMcfRedirectUrl(href: string, state: string): string | null {
  if (!MCF_REDIRECT_STATES.includes(state)) {
    return null;
  }

  const url = new URL(href);
  const targetBasePath = `/${state}`;

  if (url.pathname === targetBasePath || url.pathname.startsWith(`${targetBasePath}/`)) {
    return null;
  }
  if (!url.hash.startsWith('#/')) {
    url.hash = `${url.pathname}${url.search}${url.hash}`;
    url.search = '';
  }
  url.pathname = `${targetBasePath}/`;
  return url.toString();
}
